import SimpleQuestion from "./SimpleQuestion";
import * as theme from "../theme";
import { INSURER } from "../store/businesslogic/hardwiredlogic";
import { useEffect, useState } from "react";
import { isAnswerEmpty } from "../store/helperfuncs";
import {
  getBrokerInformation,
  retrieveBrokerageImg,
  retrieveBrokerforClient,
} from "../store/broker";
import translations from "../utils/translations";
import { useDispatch, useSelector } from "react-redux";

const NumberComponent = ({
  text,
  node,
  handleAnswerChange,
  isNodeOpen,
  qfusermode,
}) => {
  return (
    <SimpleQuestion
      leftString={text}
      node={node}
      rightComponent={
        <NumberInput
          node={node}
          handleAnswerChange={handleAnswerChange}
          qfusermode={qfusermode}
        ></NumberInput>
      }
    ></SimpleQuestion>
  );
};

const NumberInput = ({
  node,
  handleAnswerChange,
  error,
  label,
  qfusermode,
}) => {
  // const currentnode = useSelector(getCurrentNode);
  // const isOnThisNode = node.id === currentnode.id;
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;

  const [input, setInput] = useState(
    isAnswerEmpty(node.answer) ? null : node.answer
  );

  useEffect(() => {
    if (input != node.answer && node.answer) {
      setInput(node.answer);
    }
  }, [node.answer]);

  const handleAnswer = (input) => {
    if (input === "" || input === null) {
      handleAnswerChange(null);
    } else if (!isNaN(input)) {
      handleAnswerChange(Number(input));
    }
  };

  const handleBlur = (event) => {
    if (node.answer != input) handleAnswer(input);
  };

  const handleChange = (event) => {
    let input = event.target.value;
    if (input === "" || input === null || input === undefined) {
      setInput(null);
    } else if (!isNaN(input)) setInput(event.target.value);
  };

  let widthFromLogic = node.logic.width
    ? `${node.logic.width}vw`
    : theme.inputStyle.width;

  // const dispatch = useDispatch();
  return (
    <input
      type="text"
      placeholder={translations[languagepreference].enterNumber}
      id={"numberInput" + node.id}
      style={{ ...theme.inputStyle, width: widthFromLogic }}
      value={input}
      onBlur={handleBlur}
      onChange={handleChange}
      readOnly={qfusermode === INSURER ? true : false}
    ></input>
  );
};

export const NumberInputForMiniForm = ({
  node,
  handleAnswerChange,
  code,
  questionid,
  qfusermode,
}) => {
  // code = "ENGLISH";
  // questionid = "internal_1";
  // node = {
  //   answer: { internal: { ENGLISH: { internal_1: "hello this is answer" } } },
  // };
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  const decideTheValue = (code, node, questionid) => {
    if (!node) return "";
    if (!node.answer) return "";
    if (!node.answer.internal) return "";
    if (!node.answer.internal[code]) return "";
    if (!node.answer.internal[code][questionid]) return "";

    return node.answer.internal[code][questionid];
  };

  const handleAnswer = (event) => {
    let input = event.target.value;
    if (input === "") {
      handleAnswerChange(null);
    } else if (!isNaN(input)) {
      handleAnswerChange(code, questionid, Number(input));
    }
  };
  return (
    <input
      type="text"
      placeholder={translations[languagepreference].enterNumber}
      style={{ ...theme.inputStyle, width: "9vw" }}
      id={`numberInput_${node.id}_${code}_${questionid}`}
      value={decideTheValue(code, node, questionid)}
      onChange={handleAnswer}
      readOnly={qfusermode === INSURER ? true : false}
    ></input>
  );
};

export default NumberComponent;
